import { NegotiationFieldMeta, WithNestedLegs } from 'api'
import { getNegotiatedValue } from 'model'

export const doesAllPreAssignmentsHaveSameStartConsiderationOverride = doesAllPreAssignmentsHaveSameNegotiatedValue(
  NegotiationFieldMeta.START_CONSIDERATION_OVERRIDE
)

export function doesAllPreAssignmentsHaveSameNegotiatedValue(negotiableField: NegotiationFieldMeta) {
  return function<T extends WithNestedLegs>(item: T) {
    const firstLegField = item?.nestedLegs?.legs?.[0]?.negotiationFields?.[negotiableField]?.negotiableFieldRequired

    return item?.nestedLegs?.legs?.every(leg => {
      const currentLegField = leg?.negotiationFields?.[negotiableField]?.negotiableFieldRequired

      return getNegotiatedValue(currentLegField) === getNegotiatedValue(firstLegField)
    })
  }
}
